<template>
  <div
    class="bg-white rounded-xl relative w-full overflow-hidden hover:shadow transition-all duration-300 ease-in-out flex"
  >
    <div class="relative">
      <div
        :class="[post.category === 1 ? 'text-white bg-truegray-500' : '']"
        class="mb-4 rounded py-1 px-4 absolute top-6 left-3 z-40"
      >
        <h6>{{ post.category_title }}</h6>
      </div>
    </div>
    <!-- Card image -->
    <div
      v-if="post.image_featured"
      :style="{ backgroundImage: 'url(' + post.image_featured + ')' }"
      class="bg-cover bg-center relative h-full w-4/12 flex items-center justify-center flex-col"
    ></div>

    <div
      v-if="!post.image_featured"
      :style="[
        post.category === 1
          ? { backgroundImage: 'url(/img/default-news.jpg)' }
          : '',
      ]"
      class="bg-cover bg-center relative h-full w-4/12 flex items-center justify-center flex-col"
    ></div>
    <!-- /Card Image -->

    <!-- Card Content -->
    <div class="w-8/12 relative p-6 flex flex-col justify-between bg-white">
      <div>
        <h3>{{ post.title }}</h3>

        <PostTags
          v-if="post.general_tags && post.general_tags.length > 0"
          :tags="post.general_tags"
        />
      </div>

      <!-- Card base -->
      <div class="mt-auto border-t border-truegray-300 pt-3">
        <h6 class="text-truegray-400 mb-3">
          Published on {{ post.created_at_ui }}
        </h6>
        <a
          :id="post.id"
          class="z-40 pb-4"
          :class="[cloud ? 'hover:text-cw-alt' : '']"
          @click="viewPost(post.id)"
          >View post ></a
        >
      </div>
    </div>
    <!-- /Card Content -->
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import PostTags from '../../../../../../shared/components/PostTags.vue'

export default {
  components: {
    PostTags,
  },

  props: {
    post: { default: [] },
    cloud: { default: false },
  },

  data() {
    return {
      start_date_short: null,
      end_date_short: null,
      authorModalActive: false,
    }
  },

  computed: {
    ...mapGetters({
      client: 'shared/getClient',
    }),
  },

  watch: {
    post: {
      handler: function (val) {
        if (val.event_start_at_ui) {
          this.start_date_short = val.event_start_at_ui.split(',')[0]
        }
      },

      deep: true,
    },
  },

  mounted() {
    if (this.post.event_start_at_ui) {
      this.start_date_short = this.post.event_start_at_ui.split(',')[0]
    }

    if (this.post.event_end_at_ui) {
      this.end_date_short = this.post.event_end_at_ui.split(',')[0]
    }
  },

  methods: {
    viewPost(id = 0) {
      if (this.client === 'client2cloud') {
        this.$router.push({ path: `/news/${id}` })
        return
      }

      // let id = $event.target.id;
      if (this.cloud) {
        this.$router.push({ path: `/cloudpost/${id}` })
      } else {
        this.$router.push({ path: `/post/${id}` })
      }
    },

    showProfile(author) {
      if (author.type === 0) {
        this.$router.push({ path: '/organisation/' + author.id })
      } else {
        this.$router.push({ path: '/school/' + author.id })
      }
    },
  },
}
</script>

<style scoped>
.tag-item::after {
  position: absolute;
  right: -0.5rem;
  top: 50%;
  content: '';
  background: currentColor;
  height: 4px;
  width: 2px;
  border-radius: 6px;
  transform: translateY(-50%);
}

.tag-item:last-child::after {
  opacity: 0;
}
</style>
